// import React, { children } from 'react'
import Navbar from '../pages/Navbar/Navbar'
import Sidebar from '../pages/Sidebar/Sidebar'
import { StyledFullPage, StyledManiPageContent } from '../pages/dashboard/style.dashboard'

const Layouts = ({children}) => {
    return (
        <>
            <StyledFullPage>

                <Navbar/>
                <StyledManiPageContent>

                    <Sidebar/>
                    

                    {children}

                </StyledManiPageContent>

            </StyledFullPage>
        </>
    )
}

export default Layouts
